module.exports = __webpack_public_path__ + "img/ausstellung8.ab4b5c9a.jpg";